import useReveal from "@/hooks/useReveal";

const STORY_IMAGE_1 = "/positioning/positioning-1.jpg";
const STORY_IMAGE_2 = "/positioning/positioning-2.jpg";

export default function BrandPhilosophy() {
  const eyebrowRef = useReveal();
  const headRef = useReveal();
  const img1Ref = useReveal();
  const img2Ref = useReveal();
  const quoteRef = useReveal();
  const copyRef = useReveal();

  return (
    <section
      data-testid="brand-philosophy"
      className="relative py-28 md:py-40 lg:py-48 bg-bone-200/60 border-y border-borderwarm overflow-hidden"
    >
      <div className="container-luxury">
        {/* Eyebrow */}
        <div ref={eyebrowRef} className="reveal flex items-center gap-4 mb-10 md:mb-14">
          <span className="text-[11px] uppercase tracking-[0.32em] text-oxblood font-medium">
            Positioning
          </span>
          <span className="h-px flex-1 max-w-[120px] bg-borderwarm" />
        </div>

        {/* Category-defining headline */}
        <h2
          ref={headRef}
          className="reveal reveal-delay-1 font-serif text-[36px] sm:text-[48px] md:text-[64px] lg:text-[76px] xl:text-[84px] leading-[0.98] tracking-[-0.02em] text-espresso text-balance max-w-[22ch]"
        >
          Uniforms are not procurement.
          <br />
          They're
          <em className="italic font-normal text-oxblood"> guest experience </em>
          infrastructure.
        </h2>

        {/* Two-image editorial composition */}
        <div className="mt-16 md:mt-24 grid grid-cols-12 gap-5 md:gap-10">
          <div ref={img1Ref} className="reveal reveal-delay-2 col-span-7">
            <div className="aspect-[4/3] overflow-hidden bg-sandstone">
              <img
                src={STORY_IMAGE_1}
                alt="Hospitality staff in coordinated Auraa uniform programme"
                loading="lazy"
                className="w-full h-full object-cover hover:scale-[1.04] transition-transform duration-[1800ms] ease-out"
              />
            </div>
          </div>
          <div ref={img2Ref} className="reveal reveal-delay-3 col-span-5 lg:mt-20">
            <div className="aspect-[4/5] overflow-hidden bg-sandstone">
              <img
                src={STORY_IMAGE_2}
                alt="Lyfe Hotels chef in Auraa-designed kitchen uniform"
                loading="lazy"
                className="w-full h-full object-cover hover:scale-[1.04] transition-transform duration-[1800ms] ease-out"
              />
            </div>
          </div>
        </div>

        {/* Long-form editorial copy */}
        <div className="mt-16 md:mt-24 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-20">
          <div ref={quoteRef} className="reveal lg:col-span-5">
            <div className="text-[11px] uppercase tracking-[0.28em] text-oxblood mb-5">
              The Auraa View
            </div>
            <p className="font-serif italic text-[22px] md:text-[28px] lg:text-[32px] leading-[1.25] text-espresso text-balance">
              "Staff presentation is one of the most visible expressions of
              guest experience — worn, seen, photographed, remembered."
            </p>
          </div>

          <div
            ref={copyRef}
            className="reveal reveal-delay-2 lg:col-span-6 lg:col-start-7 space-y-5 text-[15px] md:text-[17px] leading-[1.85] text-espresso-soft font-light"
          >
            <p>
              Hospitality brands obsess over architecture, interiors, rituals
              and service touchpoints. Then the uniform — the single most human
              surface of the brand — is left to a catalogue.
            </p>
            <p className="text-espresso">
              Auraa designs hospitality uniform systems aligned to the
              experience your brand promises — concept, cut, fit, fabric,
              measurement, production and national rollout, held to a single
              standard.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
